export default [
    {"source": "Total Revenue","Index": 0},
    {"source": "Federal Revenue","Index": 1},
    {"source": "State Revenue","Index": 2},
    {"source": "Local Revenue","Index": 3},
    {"source": "Total Instructional","Index": 4},
    {"source": "Instructional Salary","Index": 5},
    {"source": "Instructional Benefits","Index": 6},
    {"source": "Total Support Services","Index": 7},
    {"source": "Support Services Salary","Index": 8},
    {"source": "Support Services Benefits","Index": 9},
    {"source": "Support Services - Operation & Maintenance","Index": 10},
    {"source": "Support Services - Pupil Support Services","Index": 11},
    {"source": "Support Services - School Administration","Index": 12},
    {"source": "Support Services - Instructional Staff","Index": 13},
    {"source": "Support Services - Pupil Transportation","Index": 14},
    {"source": "Support Services - Other","Index": 15},
    {"source": "Support Services - General Administration","Index": 16},
    {"source": "Capital Outlay","Index": 17},
    {"source": "Debt","Index": 18},
    {"source": "Enrollment","Index": 19}
]